/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {HarvestRecommendation} from '../bioplanModels';
/**
 * PlanningRecommendHarvestApi - axios parameter creator
 * @export
 */
export const PlanningRecommendHarvestApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get recommended harvests for a plan
     * @param {string} planId
     * @param {string} date
     * @param {number} [maxRecommendations]
     * @param {string} [siteId]
     * @param {number} [biomass]
     * @param {RecommendHarvestsGetSortByEnum} [sortBy]
     * @param {Array<string>} [excludeWithProperties] A list of ids of fish group properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendHarvestsGet: async (
      planId: string,
      date: string,
      maxRecommendations?: number,
      siteId?: string,
      biomass?: number,
      sortBy?: RecommendHarvestsGetSortByEnum,
      excludeWithProperties?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('recommendHarvestsGet', 'planId', planId);
      // verify required parameter 'date' is not null or undefined
      assertParamExists('recommendHarvestsGet', 'date', date);
      const localVarPath = `/recommendHarvests/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString().substring(0, 10) : date;
      }

      if (maxRecommendations !== undefined) {
        localVarQueryParameter['maxRecommendations'] = maxRecommendations;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (biomass !== undefined) {
        localVarQueryParameter['biomass'] = biomass;
      }

      if (sortBy !== undefined) {
        localVarQueryParameter['sortBy'] = sortBy;
      }

      if (excludeWithProperties) {
        localVarQueryParameter['excludeWithProperties'] = excludeWithProperties;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningRecommendHarvestApi - functional programming interface
 * @export
 */
export const PlanningRecommendHarvestApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningRecommendHarvestApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get recommended harvests for a plan
     * @param {string} planId
     * @param {string} date
     * @param {number} [maxRecommendations]
     * @param {string} [siteId]
     * @param {number} [biomass]
     * @param {RecommendHarvestsGetSortByEnum} [sortBy]
     * @param {Array<string>} [excludeWithProperties] A list of ids of fish group properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async recommendHarvestsGet(
      planId: string,
      date: string,
      maxRecommendations?: number,
      siteId?: string,
      biomass?: number,
      sortBy?: RecommendHarvestsGetSortByEnum,
      excludeWithProperties?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HarvestRecommendation>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.recommendHarvestsGet(
        planId,
        date,
        maxRecommendations,
        siteId,
        biomass,
        sortBy,
        excludeWithProperties,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningRecommendHarvestApi.recommendHarvestsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningRecommendHarvestApi - factory interface
 * @export
 */
export const PlanningRecommendHarvestApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningRecommendHarvestApiFp(configuration);
  return {
    /**
     *
     * @summary Get recommended harvests for a plan
     * @param {PlanningRecommendHarvestApiRecommendHarvestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendHarvestsGet(
      requestParameters: PlanningRecommendHarvestApiRecommendHarvestsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<HarvestRecommendation>> {
      return localVarFp
        .recommendHarvestsGet(
          requestParameters.planId,
          requestParameters.date,
          requestParameters.maxRecommendations,
          requestParameters.siteId,
          requestParameters.biomass,
          requestParameters.sortBy,
          requestParameters.excludeWithProperties,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for recommendHarvestsGet operation in PlanningRecommendHarvestApi.
 * @export
 * @interface PlanningRecommendHarvestApiRecommendHarvestsGetRequest
 */
export interface PlanningRecommendHarvestApiRecommendHarvestsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningRecommendHarvestApiRecommendHarvestsGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningRecommendHarvestApiRecommendHarvestsGet
   */
  readonly date: string;

  /**
   *
   * @type {number}
   * @memberof PlanningRecommendHarvestApiRecommendHarvestsGet
   */
  readonly maxRecommendations?: number;

  /**
   *
   * @type {string}
   * @memberof PlanningRecommendHarvestApiRecommendHarvestsGet
   */
  readonly siteId?: string;

  /**
   *
   * @type {number}
   * @memberof PlanningRecommendHarvestApiRecommendHarvestsGet
   */
  readonly biomass?: number;

  /**
   *
   * @type {'weight' | 'score'}
   * @memberof PlanningRecommendHarvestApiRecommendHarvestsGet
   */
  readonly sortBy?: RecommendHarvestsGetSortByEnum;

  /**
   * A list of ids of fish group properties
   * @type {Array<string>}
   * @memberof PlanningRecommendHarvestApiRecommendHarvestsGet
   */
  readonly excludeWithProperties?: Array<string>;
}

/**
 * PlanningRecommendHarvestApi - object-oriented interface
 * @export
 * @class PlanningRecommendHarvestApi
 * @extends {BaseAPI}
 */
export class PlanningRecommendHarvestApi extends BaseAPI {
  /**
   *
   * @summary Get recommended harvests for a plan
   * @param {PlanningRecommendHarvestApiRecommendHarvestsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningRecommendHarvestApi
   */
  public recommendHarvestsGet(
    requestParameters: PlanningRecommendHarvestApiRecommendHarvestsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningRecommendHarvestApiFp(this.configuration)
      .recommendHarvestsGet(
        requestParameters.planId,
        requestParameters.date,
        requestParameters.maxRecommendations,
        requestParameters.siteId,
        requestParameters.biomass,
        requestParameters.sortBy,
        requestParameters.excludeWithProperties,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const RecommendHarvestsGetSortByEnum = {
  Weight: 'weight',
  Score: 'score',
} as const;
export type RecommendHarvestsGetSortByEnum =
  (typeof RecommendHarvestsGetSortByEnum)[keyof typeof RecommendHarvestsGetSortByEnum];
